import { Field, FieldArray } from "formik";
import React, { useState, useContext } from "react";
import {
  clearLocalCacheByModel,
  createPlanStore,
  savePlanDetailsAction,
  setManagePageLevelData,
  setManagePlanLocalCache,
  setManagePlanToastInfo,
} from "../../../contexts";
import {
  FieldButtonGroup,
  CsplTable as Table,
  FieldInputDollar,
  FieldInputPercentage,
  FieldInputNumber,
} from "../../../components";
import {
  getPlanSourceInformation,
  getPlanInvestments,
} from "../../../services";
import {
  yesNoOptions,
  required,
  Enrollment_applyADITo,
  Enrollment_autoDeferralIncreaseApplicableTo,
  Enrollment_periodOfIncrease,
  Enrollment_allocationPercentageForReHire,
} from "../../../utils";
import { useRouterParams, useRequest } from "../../../abstracts";
import { get, isEmpty } from "lodash";

const columns = [
  {
    label: "Source",
    className: "column-source",
    columnName: "sourceName",
  },
  {
    label: "Auto Deferral Increase",
    className: "column-autoDeferralIncrease",
    columnName: "autoDeferralIncrease",
  },
  {
    label: "Maximum ADI",
    className: "column-maximumADI",
    columnName: "maximumADI",
  },
];

const ADIApplicableFields = (props) => {
  const {
    fields,
    values,
    setFieldValue,
    isEdit,
    isSave,
    handleChange,
    planId,
    transformedEmployeeDeferralSourceList,
    adiSources,
  } = props;

  const sources = !isEmpty(get(values, "autoDeferralncreaseApplicable.adi", []))
    ? get(values, "autoDeferralncreaseApplicable.adi")
    : get(values, "adi");
  return (
    <div>
      <p className="mt-20 plan-sub-heading">ADI Applicable</p>
      <Field
        size="sm"
        isRequired
        name="autoDeferralncreaseApplicable.autoDeferralIncreaseProgram"
        label={"Auto Deferral increase program"}
        options={yesNoOptions}
        selectedValue={get(
          values,
          "autoDeferralncreaseApplicable.autoDeferralIncreaseProgram"
        )}
        value="autoDeferralncreaseApplicable.autoDeferralIncreaseProgram"
        onChange={(value) => {
          setFieldValue(
            `autoDeferralncreaseApplicable.autoDeferralIncreaseProgram`,
            value
          );
          if (value) {
            setFieldValue(
              `autoDeferralncreaseApplicable.autoDeferralIncrease`,
              3
            );
            setFieldValue(`autoDeferralncreaseApplicable.periodOfIncrease`, 1);
          } else {
            setFieldValue(
              `autoDeferralncreaseApplicable.autoDeferralIncrease`,
              null
            );
            setFieldValue(
              `autoDeferralncreaseApplicable.periodOfIncrease`,
              null
            );
            setFieldValue(`autoDeferralncreaseApplicable.applyADITo`, null);
            setFieldValue(`autoDeferralncreaseApplicable.adi`, adiSources());
          }
        }}
        component={FieldButtonGroup}
        //validate={required}
        disabled={isEdit && !isSave}
      />
      {get(
        values,
        "autoDeferralncreaseApplicable.autoDeferralIncreaseProgram"
      ) === true ? (
        <>
          {/* <Field
            size="sm"
            isRequired
            name="autoDeferralncreaseApplicable.autoDeferralIncrease"
            label={"Auto Deferral increase applicable to"}
            options={Enrollment_autoDeferralIncreaseApplicableTo}
            selectedValue={get(
              values,
              "autoDeferralncreaseApplicable.autoDeferralIncrease"
            )}
            value="autoDeferralncreaseApplicable.autoDeferralIncrease"
            onChange={(value) => {
              setFieldValue(
                `autoDeferralncreaseApplicable.autoDeferralIncrease`,
                value
              );
            }}
            component={FieldButtonGroup}
            //validate={required}
            disabled={isEdit && !isSave}
          /> */}
          <Field
            size="md1"
            isRequired
            name="autoDeferralncreaseApplicable.periodOfIncrease"
            label={"Period of increase"}
            options={Enrollment_periodOfIncrease}
            selectedValue={get(
              values,
              "autoDeferralncreaseApplicable.periodOfIncrease"
            )}
            value="autoDeferralncreaseApplicable.periodOfIncrease"
            onChange={(value) => {
              setFieldValue(
                `autoDeferralncreaseApplicable.periodOfIncrease`,
                value
              );
            }}
            component={FieldButtonGroup}
            //validate={required}
            disabled={isEdit && !isSave}
          />
          <div className="w-100">
            <div className="d-flex justify-content-between mb-4">
              <div className="">
                <div className="m-0 plan-sub-heading mt-2">
                  Auto Deferral Increase
                </div>
              </div>
            </div>
          </div>
          <Table className="auto-deferral-increase-table">
            <Table.Thead>
              <Table.Tr>
                {columns.map((item, index) => {
                  return (
                    <Table.Th
                      key={index}
                      className={(item.className, "col-md-3")}
                    >
                      {item.label}
                    </Table.Th>
                  );
                })}
              </Table.Tr>
            </Table.Thead>
            <FieldArray name="adi">
              <Table.Tbody>
                {!isEmpty(sources) &&
                  sources.map((sourceDeferral, index) => {
                    return (
                      <Table.Tr key={index}>
                        {columns.map((item, cellIndex) => {
                          const getContent = () => {
                            if (item.columnName === "autoDeferralIncrease") {
                              const fieldName = !isEmpty(
                                get(
                                  values,
                                  "autoDeferralncreaseApplicable.adi",
                                  []
                                )
                              )
                                ? `autoDeferralncreaseApplicable.adi.${index}.autoDeferralIncrease`
                                : `adi.${index}.autoDeferralIncrease`;
                              return (
                                <Field
                                  size="sm"
                                  isRequired
                                  name={fieldName}
                                  type="number"
                                  autoComplete="off"
                                  value={get(values, fieldName)}
                                  onChange={handleChange(fieldName)}
                                  preventNegative={true}
                                  isAllowNegative={false}
                                  component={
                                    get(
                                      transformedEmployeeDeferralSourceList,
                                      `[${index}].contributionType`,
                                      null
                                    ) === 2
                                      ? FieldInputDollar
                                      : FieldInputPercentage
                                  }
                                  disabled={isEdit && !isSave}
                                  max={
                                    get(
                                      transformedEmployeeDeferralSourceList,
                                      `[${index}].contributionType`,
                                      null
                                    ) === 2
                                      ? 9999999
                                      : 100
                                  }
                                />
                              );
                            }
                            if (item.columnName === "maximumADI") {
                              const fieldName = !isEmpty(
                                get(
                                  values,
                                  "autoDeferralncreaseApplicable.adi",
                                  []
                                )
                              )
                                ? `autoDeferralncreaseApplicable.adi.${index}.maximumADI`
                                : `adi.${index}.maximumADI`;
                              return (
                                <Field
                                  size="sm"
                                  isRequired
                                  name={fieldName}
                                  type="number"
                                  autoComplete="off"
                                  value={get(values, fieldName)}
                                  onChange={handleChange(fieldName)}
                                  preventNegative={true}
                                  isAllowNegative={false}
                                  component={
                                    get(
                                      transformedEmployeeDeferralSourceList,
                                      `[${index}].contributionType`,
                                      null
                                    ) === 2
                                      ? FieldInputDollar
                                      : FieldInputPercentage
                                  }
                                  disabled={isEdit && !isSave}
                                  max={
                                    get(
                                      transformedEmployeeDeferralSourceList,
                                      `[${index}].contributionType`,
                                      null
                                    ) === 2
                                      ? 9999999
                                      : 100
                                  }
                                />
                              );
                            }
                            return sourceDeferral.sourceName;
                          };
                          return (
                            <Table.Td
                              key={cellIndex}
                              className={(item.className, "col-md-3")}
                              // style="vertical-align-top"
                            >
                              {getContent()}
                            </Table.Td>
                          );
                        })}
                      </Table.Tr>
                    );
                  })}
              </Table.Tbody>
            </FieldArray>
          </Table>
          <Field
            size="md1"
            name="autoDeferralncreaseApplicable.applyADITo"
            label={"Apply ADI To"}
            isRequired
            options={Enrollment_applyADITo}
            selectedValue={get(
              values,
              "autoDeferralncreaseApplicable.applyADITo"
            )}
            value="autoDeferralncreaseApplicable.applyADITo"
            onChange={(value) => {
              setFieldValue(`autoDeferralncreaseApplicable.applyADITo`, value);
            }}
            component={FieldButtonGroup}
            disabled={isEdit && !isSave}
          />
        </>
      ) : null}
    </div>
  );
};

export default ADIApplicableFields;
